<template>
    <b-modal id="staff-message" :title="title" @ok="sendMessage" ref="messageModal">
        <div class="form-group inline-label">
            <label for="staff-message-textarea" class="label-bid-message">
                Message
                <span @click="addEmojiMessage('&#x1F6AD')" class="cursor-pointer">&#x1F6AD</span>
                <span @click="addEmojiMessage('&#x1F44D')" class="cursor-pointer">&#x1F44D</span>
                <span @click="addEmojiMessage('&#x1F44E')" class="cursor-pointer">&#x1F44E</span>
                <span @click="addEmojiMessage('&#x1F44C')" class="cursor-pointer">&#x1F44C</span>
                <span @click="addEmojiMessage('&#x1F645')" class="cursor-pointer">&#x1F645</span>
            </label>
            <textarea ref="message" id="staff-message-textarea" v-model="message"></textarea>
        </div>
        <ul class="preset-message-list">
            <li v-for="(msg, index) in default_messages">
                <a href="#!" @click="addToMessage(index)" :class="msg.used ? 'used' : 'not-used'">{{msg.msg}}</a>
            </li>
        </ul>
    </b-modal>

</template>
<script>
import {handleHttpError} from '../../util/common'
export default {
    created(){
    },
    mounted(){
    },
    data() {
        return {
            message: null,
            vehicle: null,
            user: {name: ''},
            withEmail: false,
            default_messages:[],
        }
    },
    computed: {
        title(){
            return 'Staff Message Only'
        }
    },
    methods: {
        openModal(vehicle, msg){
            this.$refs.messageModal.show();
            this.message = msg;
            this.vehicle = vehicle;
            // focus the textarea in 200ms, 500ms, and 1000ms
            const delays = [200, 500, 1000];
            delays.forEach(delay => {
                setTimeout(() => {
                    if (this.message == '') {
                        // only focus if the message is empty
                        this.$refs.message.focus();
                    }
                }, delay);
            });
        },
        addEmojiMessage(emoji){
            let div = document.createElement('div');
            div.innerHTML = emoji;
            this.message += div.textContent
        },
        addToMessage(index){
            this.default_messages[index].used = true;
            let message = this.default_messages[index].msg
            let current_position = this.$refs.message.selectionStart || this.$refs.message.textLength;
            let msg_start = this.message.substring(0,current_position);
            let msg_end = this.message.substring(current_position);
            this.message = msg_start + ' ' + message + ' ' + msg_end;
        },
        async sendMessage(){
            try {
                let vehicle_id = this.vehicle.api_id;
                let message = this.message;
                let result = await this.$store.dispatch('userBids/addVehicleMessage', {
                    vehicle_id,
                    message,
                });
                if (result && result.vehicle_message) {
                    this.$emit('changed', this.vehicle, result.vehicle_message, result);
                }
            } catch (e) {
                handleHttpError(e);
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleSingle/StaffMessage.vue